import React from 'react'
// import { Chapters } from 'content/chapters'

const LessonArticle = props => {
  return null
  // const id = props.chapter.id < 10 ? `0${props.chapter.id}` : props.chapter.id
  // const Chapter = Chapters[`Chapter${id}`]
  //
  // if(!Chapter) return <div>No Template</div>
  //
  // const lessonId = props.lesson.id < 10 ? `0${props.lesson.id}` : props.lesson.id
  // const Lesson = Chapter[`Lesson${lessonId}`]
  //
  // if(!Lesson) return <div>No Template</div>
  //
  // return <Lesson {...props} />
}

export default LessonArticle
